var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "keyboard_double_arrow_right_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_18893",
    "data-name": "\\uADF8\\uB8F9 18893"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1796",
    "data-name": "\\uC0AC\\uAC01\\uD615 1796",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1797",
    "data-name": "\\uC0AC\\uAC01\\uD615 1797",
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_18895",
    "data-name": "\\uADF8\\uB8F9 18895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_18894",
    "data-name": "\\uADF8\\uB8F9 18894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_47",
    "data-name": "\\uD328\\uC2A4 47",
    d: "M5.7,6.71h0a1,1,0,0,0,0,1.41L9.58,12,5.7,15.88a1,1,0,0,0,0,1.41h0a1,1,0,0,0,1.41,0L11.7,12.7a1,1,0,0,0,0-1.41L7.12,6.71A1.008,1.008,0,0,0,5.7,6.71Z",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_48",
    "data-name": "\\uD328\\uC2A4 48",
    d: "M12.29,6.71h0a1,1,0,0,0,0,1.41L16.17,12l-3.88,3.88a1,1,0,0,0,0,1.41h0a1,1,0,0,0,1.41,0l4.59-4.59a1,1,0,0,0,0-1.41L13.7,6.7A1,1,0,0,0,12.29,6.71Z",
    fill: "#777"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowRight);
export default __webpack_public_path__ + "static/media/double_arrow_right.09f713ecb855f6dd37bdf65077446efc.svg";
export { ForwardRef as ReactComponent };